<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>日志</h6>
			<!--<el-button class="titBtn" type="success" @click="canvas" icon="el-icon-refresh">canvas</el-button>-->
			<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			<el-button class="titBtn" type="success" icon="el-icon-search" @click="query()">搜索</el-button>
			<!--<el-input class="querys" v-model.trim="dw" placeholder="名称"></el-input>-->
			<el-date-picker v-model.trim="endTime" class="querys" value-format="yyyy-MM-dd" placeholder="结束时间" type="date"></el-date-picker>
			
			<el-date-picker class="querys" v-model.trim="beginTime" value-format="yyyy-MM-dd" placeholder="开始时间" type="date"></el-date-picker>

			
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="username" align='center' label="操作人姓名"></el-table-column>
				<el-table-column prop="createDate" align='center' label="创建时间"></el-table-column>
				<el-table-column prop="operation" align='center' label="操作内容"></el-table-column>
				<el-table-column prop="params" align='center' label="请求参数"></el-table-column>
				<el-table-column prop="method" align='center' label="请求方法"></el-table-column>
				<el-table-column prop="ip" align='center' label="IP地址"></el-table-column>

			</el-table>

		</div>

		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums"></pagintion>
		</div>
		<canvasdemo  v-if="dialogVisible == true" @adddata="addData"></canvasdemo>
	</div>
</template>

<script>
	import pagintion from '@/components/mangement/pagintion.vue';
	
	import canvasdemo from'./popup/canvas.vue'
	import { journallist } from "@/api/api";

	export default {
		data() {
			return {
				tabledata: [{}, {}, {}, ],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 0, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row: null,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				beginTime:'',
				endTime:'',
			}
		},
		components: {
			canvasdemo,
			pagintion
		},
		mounted() {
			let params = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,

			}
			this.list(params)
		},
		methods: {
			addData(){
				this.dialogVisible = false
				
			},
			canvas(){
				this.dialogVisible = true
			},
			list(params) {

				journallist(params).then((res) => {
					console.log(res)
					this.total = res.total;
					this.tabledata = res.data;

				})
			},

			DsyData(data) { //多少页
				this.pageNum = data.dsy;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					
				}
				this.list(params)
			},
			DstData(data) { //多少条
				this.pageSize = data.dst;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,

				}
				this.list(params)
			},
			addClick() {
				this.dialogVisible = true;
				this.Addsid = ["xz"];
			},
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			Adddata(data) {
				this.dialogVisible = data.dialogVisible;

			},
			rowClick(row) {
				this.row = row;
			},
			edit(row, index) {
				this.dialogVisible = true;
				this.Addsid = ["bj", row];
			},
			query(){
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					beginTime: this.beginTime, //开始时间
					endTime: this.endTime, //结束时间
				}
				this.list(params)
			},
			reset() {
				this.beginTime = '';
				this.endTime = '';

				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,

				}
				this.list(params)
			},
			deletes(row, index) {

				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {

						deletemenu({}, row.id).then((res) => {

							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
								// this.menuList({})
							} else {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
							}
						});

					}
				}).catch(() => {

				});

			},
		}
	}
</script>

<style scoped>
	@import url('../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}
	
	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		font-size: 14px;
	}
	>>>.el-input__icon{
		line-height: 30px;
	}
</style>